import { faCircleCheck } from "@fortawesome/pro-regular-svg-icons/faCircleCheck";
import { faCircleExclamation } from "@fortawesome/pro-regular-svg-icons/faCircleExclamation";
import { faCircleInfo } from "@fortawesome/pro-regular-svg-icons/faCircleInfo";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  hideNotification,
  type NotificationData,
  showNotification,
  updateNotification,
} from "@mantine/notifications";
import type { ReactNode } from "react";
import { twMerge } from "tailwind-merge";

export enum NotificationTypes {
  Error = "Error",
  Info = "Info",
  Success = "Success",
}

type PartialConfig = Partial<NotificationData>;

const configByType: Record<NotificationTypes, PartialConfig> = {
  [NotificationTypes.Error]: {
    bg: "red.1",
    icon: <FontAwesomeIcon icon={faCircleExclamation} />,
  },
  [NotificationTypes.Info]: {
    bg: "gray.0",
    icon: <FontAwesomeIcon icon={faCircleInfo} />,
  },
  [NotificationTypes.Success]: {
    bg: "mint-green.0",
    icon: <FontAwesomeIcon icon={faCircleCheck} />,
  },
};

export const NOTIFICATION_CLASS_NAMES = {
  icon: twMerge(["bg-transparent", "text-uw-gray-9"]),
  root: twMerge([
    "rounded",
    "drop-shadow-[0_0_12px_rgba(0,0,0,0.10)]",
    "p-3",
    "pl-4",
  ]),
};

export const showUpwageNotification = (
  message: ReactNode,
  type = NotificationTypes.Info,
  config: PartialConfig = {},
) => {
  const id = showNotification({
    classNames: NOTIFICATION_CLASS_NAMES,
    message,
    ...configByType[type],
    ...config,
  });

  return {
    hide: () => hideNotification(id),
    id,
    update: (updates: PartialConfig) =>
      updateNotification({
        id,
        ...updates,
        message: updates.message ?? message,
      }),
  };
};
